import { useState } from "react";
import { Link } from "react-router-dom";
import { AuthLayout } from "./Login";
import api, { formatApiError } from "@/lib/api";
import { ArrowRight, Mail } from "lucide-react";
import { useTr } from "@/i18n/translator";

export default function ForgotPassword() {
  const tr = useTr();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(null);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(data);
    } catch (ex) {
      setErr(formatApiError(ex.response?.data?.detail) || ex.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title={tr("Recupera tu acceso")} subtitle={tr("OLVIDÉ MI CONTRASEÑA")}>
      {sent ? (
        <div className="space-y-4" data-testid="forgot-sent">
          <div className="border border-[#0A0A0A] bg-[#FFD600] p-4 flex items-start gap-3">
            <Mail className="w-5 h-5 shrink-0 mt-0.5" />
            <div className="font-mono-data text-sm">
              {sent.message}
            </div>
          </div>
          {sent.dev_mode && sent.reset_url && (
            <div className="border border-[#E53935] bg-[#E53935]/5 p-4">
              <div className="font-mono-mark text-[10px] text-[#E53935] mb-2">MODO DEV · LINK DIRECTO</div>
              <a href={sent.reset_url} className="font-mono-data text-xs break-all underline" data-testid="forgot-dev-link">
                {sent.reset_url}
              </a>
            </div>
          )}
          <Link to="/login" className="block text-center font-mono-mark text-[10px] underline decoration-[#E53935]">
            VOLVER A LOGIN
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <p className="font-mono-data text-sm text-[#5C5C5C]">
            {tr("Ingresa tu correo y te enviaremos un link para crear una contraseña nueva.")}
          </p>
          <label className="block">
            <span className="font-mono-mark text-[10px] text-[#5C5C5C]">EMAIL</span>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full mt-2 bg-white border border-[#0A0A0A] px-4 py-3 font-mono-data text-sm focus:outline-none focus:ring-2 focus:ring-[#E53935]"
              placeholder={tr("tu@empresa.com")}
              data-testid="forgot-email"
            />
          </label>
          {err && (
            <div className="border border-[#E53935] bg-[#E53935]/10 px-4 py-3 font-mono-data text-sm text-[#E53935]">
              {err}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#0A0A0A] text-white px-4 py-3 font-mono-mark text-xs hover-brutal border border-[#0A0A0A] flex items-center justify-center gap-2 disabled:opacity-50"
            data-testid="forgot-submit"
          >
            {loading ? "ENVIANDO…" : "ENVIAR LINK"}
            {!loading && <ArrowRight className="w-4 h-4" />}
          </button>
          <div className="text-center font-mono-data text-sm">
            <Link to="/login" className="underline decoration-[#E53935] underline-offset-4">Volver a login</Link>
          </div>
        </form>
      )}
    </AuthLayout>
  );
}
